import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, Switch, FormControlLabel, Chip, Divider } from '@mui/material';

// 🎯 Утримання (Retention AI) — черга апруву персональних промо-акцій.
// Стиль дзеркалить AnalystPage.js (fetch + Bearer token). Toggle керує крон-агентом.
export default function RetentionPage() {
  const [status, setStatus] = useState({ enabled: false, pending: 0, active: 0, rejected: 0, expired: 0 });
  const [offers, setOffers] = useState([]);
  const [events, setEvents] = useState([]);
  const [running, setRunning] = useState(false);
  const [msg, setMsg] = useState('');
  const tok = localStorage.getItem('dashboard_token');
  const H = { Authorization: 'Bearer ' + tok };

  const load = () => {
    fetch('/api/retention/status', { headers: H }).then(r => r.json())
      .then(d => setStatus(d || {})).catch(() => {});
    fetch('/api/retention/pending', { headers: H }).then(r => r.json())
      .then(d => setOffers((d && d.offers) || [])).catch(() => {});
    fetch('/api/retention/events?limit=50', { headers: H }).then(r => r.json())
      .then(d => setEvents((d && d.events) || [])).catch(() => {});
  };
  useEffect(() => { load(); const i = setInterval(load, 15000); return () => clearInterval(i); }, []);

  const runNow = async () => {
    setRunning(true); setMsg('⏳ Запускаю генерацію... (ШІ думає, 5–30с)');
    try {
      const r = await fetch('/api/retention/run', { method: 'POST', headers: H }).then(r => r.json());
      if (r && r.api_error)
        setMsg(`⚠️ ${r.api_error} (просканував ${r.scanned}, створив ${r.created})`);
      else if (r && r.status === 'ok')
        setMsg(`✅ Готово: просканував ${r.scanned}, створив ${r.created}, заблокував ${r.blocked}, помилок ${r.errors}`);
      else setMsg('⚠️ ' + ((r && r.detail) || 'помилка запуску'));
    } catch (e) { setMsg('⚠️ помилка мережі'); }
    setRunning(false); load();
    setTimeout(() => setMsg(''), 8000);
  };

  const toggle = async (enabled) => {
    setStatus(s => ({ ...s, enabled }));  // оптимістично
    await fetch('/api/retention/toggle?enabled=' + enabled, { method: 'POST', headers: H });
    setMsg(enabled ? '✅ Retention увімкнено' : '⛔ Retention вимкнено');
    setTimeout(() => setMsg(''), 2500); load();
  };

  const approve = async (id) => {
    setMsg('⏳ Схвалюю...');
    const r = await fetch('/api/retention/approve?offer_id=' + id, { method: 'POST', headers: H }).then(r => r.json());
    setMsg(r && r.sent_to_user ? '✅ Схвалено, надіслано юзеру' : '✅ Схвалено (юзеру не надіслано)');
    setTimeout(() => setMsg(''), 3000); load();
  };

  const reject = async (id) => {
    const reason = window.prompt('Причина відхилення (необовʼязково):', '') || '';
    await fetch('/api/retention/reject?offer_id=' + id + '&reason=' + encodeURIComponent(reason), { method: 'POST', headers: H });
    setMsg('❌ Відхилено'); setTimeout(() => setMsg(''), 2500); load();
  };

  const marginColor = (m) => (m >= 75 ? '#4caf50' : m >= 65 ? '#ff9800' : '#f44336');

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ color: '#FFD700', mb: 2 }}>🎯 Утримання (Retention AI)</Typography>

      {/* Керування вмик/вимк */}
      <Paper sx={{ p: 2, mb: 2, bgcolor: '#1a1a2e' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
          <FormControlLabel
            control={<Switch checked={!!status.enabled} onChange={e => toggle(e.target.checked)} color="success" />}
            label={<Typography sx={{ color: '#fff' }}>{status.enabled ? '🟢 Агент увімкнено' : '⛔ Агент вимкнено'}</Typography>}
          />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Chip label={`⏳ У черзі: ${status.pending || 0}`} sx={{ bgcolor: 'rgba(255,152,0,0.2)', color: '#ff9800' }} />
            <Chip label={`🟢 Активні: ${status.active || 0}`} sx={{ bgcolor: 'rgba(76,175,80,0.2)', color: '#4caf50' }} />
            <Chip label={`❌ Відхилені: ${status.rejected || 0}`} sx={{ bgcolor: 'rgba(244,67,54,0.15)', color: '#f44336' }} />
          </Box>
        </Box>
        <Typography variant="caption" sx={{ color: '#888', display: 'block', mt: 1 }}>
          Крон запускає раз на день. Кнопка нижче — запустити ЗАРАЗ вручну. Акції йдуть юзеру ТІЛЬКИ після вашого «Схвалити».
        </Typography>
        <Box sx={{ mt: 1.5, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button variant="contained" onClick={runNow} disabled={running}
            sx={{ bgcolor: 'var(--ac1, #7c4dff)', '&:hover': { bgcolor: 'var(--ac1d, #5e35d6)' } }}>
            {running ? '⏳ Працює...' : '▶ Запустити зараз'}
          </Button>
          {msg && <Typography variant="caption" sx={{ color: running ? '#ff9800' : '#4caf50' }}>{msg}</Typography>}
        </Box>
      </Paper>

      {/* Хід подій (журнал) */}
      <Typography variant="subtitle1" sx={{ color: '#fff', mb: 1 }}>📜 Хід подій</Typography>
      <Paper sx={{ p: 1.5, mb: 2, bgcolor: '#0f1420', maxHeight: 260, overflowY: 'auto' }}>
        {events.length === 0 && <Typography variant="caption" sx={{ color: '#888' }}>Ще не було запусків. Натисни «▶ Запустити зараз».</Typography>}
        {events.map(ev => {
          const ico = { run_start: '▶️', run_done: '🏁', offer: '🎁', block: '🛑', error: '⚠️' }[ev.kind] || '•';
          const col = { offer: '#4caf50', block: '#ff9800', error: '#f44336', run_done: 'var(--ac1, #7c4dff)' }[ev.kind] || '#aaa';
          const t = ev.created_at ? new Date(ev.created_at).toLocaleString('uk-UA', { hour12: false }) : '';
          return (
            <Box key={ev.id} sx={{ display: 'flex', gap: 1, py: 0.3, borderBottom: '1px solid #1c2333' }}>
              <Typography variant="caption" sx={{ color: '#666', minWidth: 130 }}>{t}</Typography>
              <Typography variant="caption" sx={{ color: col }}>{ico} {ev.message}</Typography>
            </Box>
          );
        })}
      </Paper>

      {/* Черга на схвалення */}
      <Typography variant="subtitle1" sx={{ color: '#fff', mb: 1 }}>📥 Черга на схвалення</Typography>
      {offers.length === 0 && (
        <Typography variant="body2" sx={{ color: '#888' }}>Порожньо — нових пропозицій немає.</Typography>
      )}
      {offers.map(o => (
        <Paper key={o.id} sx={{ p: 2, mb: 1.5, bgcolor: '#16213e' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
            <Box>
              <Typography sx={{ color: '#fff', fontWeight: 'bold' }}>
                {o.telegram_username ? '@' + o.telegram_username : 'user #' + o.beneficiary_user_id}
                <Chip size="small" label={o.promo_type} sx={{ ml: 1, bgcolor: 'rgba(var(--ac1rgb, 124, 77, 255),0.2)', color: 'var(--ac1, #7c4dff)' }} />
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mt: 0.5, flexWrap: 'wrap' }}>
                <Typography variant="caption" sx={{ color: '#ddd' }}>Множник: <b>×{Number(o.reward_multiplier).toFixed(2)}</b></Typography>
                <Typography variant="caption" sx={{ color: '#ddd' }}>Тривалість: <b>{o.duration_hours}г</b></Typography>
                <Typography variant="caption" sx={{ color: marginColor(o.estimated_margin) }}>
                  Маржа: <b>{Number(o.estimated_margin).toFixed(1)}%</b>
                </Typography>
                <Typography variant="caption" sx={{ color: '#aaa' }}>
                  Прогноз 30д: {Number(o.projected_30d_ratio).toFixed(1)}% · вартість ~€{Number(o.projected_cost_eur).toFixed(2)}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Button size="small" variant="contained" color="success" onClick={() => approve(o.id)}>✅ Схвалити</Button>
              <Button size="small" variant="outlined" color="error" onClick={() => reject(o.id)}>❌ Відхилити</Button>
            </Box>
          </Box>
          <Divider sx={{ borderColor: '#333', my: 1 }} />
          <Typography variant="body2" sx={{ color: '#ccc', whiteSpace: 'pre-wrap' }}>{o.pitch_text}</Typography>
        </Paper>
      ))}
    </Box>
  );
}
